








import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class ToggleTitle extends Vue {
  @Prop({required: true})
  public value?: boolean;

  @Prop({required: true})
  public title?: string;

  @Prop({required: true})
  public icon?: string;

  @Prop({required: false})
  public size?: string;

  public clicked() {
      this.$emit('input', !this.value);
  }

  get sizeValue() {
    if (this.size == null || this.size === '') {
      return 'h5';
    }
    return this.size;
  }
}
